export default {"src":"/_next/static/media/CheckBoxNotActive.c34614b4.svg","height":20,"width":18,"blurWidth":0,"blurHeight":0};